'use client';

import React, { useCallback, useEffect, useState } from 'react';
import { EmblaCarouselType } from 'embla-carousel';
import { Typography, Box } from '@wishket/design-system';

type UseSelectedSnapDisplayType = {
  selectedSnap: number;
  snapCount: number;
};

export const useSelectedSnapDisplay = (
  emblaApi: EmblaCarouselType | undefined
): UseSelectedSnapDisplayType => {
  const [selectedSnap, setSelectedSnap] = useState(0);
  const [snapCount, setSnapCount] = useState(0);

  const updateScrollSnapState = useCallback((emblaApi: EmblaCarouselType) => {
    setSnapCount(emblaApi.scrollSnapList().length);
    setSelectedSnap(emblaApi.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollSnapState(emblaApi);
    emblaApi.on('select', updateScrollSnapState);
    emblaApi.on('reInit', updateScrollSnapState);
  }, [emblaApi, updateScrollSnapState]);

  return {
    selectedSnap,
    snapCount,
  };
};

type SelectedSnapDisplayProp = {
  selectedSnap: number;
  snapCount: number;
  autoplayIsPlaying: boolean;
  onToggle: () => void;
};

// TODO: play, stop, slash svg를 SystemIcon으로 변경
export const SelectedSnapDisplay = ({
  selectedSnap,
  snapCount,
  autoplayIsPlaying,
  onToggle,
}: SelectedSnapDisplayProp) => {
  return (
    <Box className="flex h-[30px] gap-[1px]">
      <Box className="flex items-center justify-center rounded-l-3xl bg-w-black/50 py-[3px] pl-3 pr-2">
        <button
          onClick={onToggle}
          data-id="featured-content-carousel-play-button"
        >
          {autoplayIsPlaying ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M4.5 3V11"
                stroke="white"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 3V11"
                stroke="white"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M6.3496 1.69167L11.1471 4.95493C11.1753 4.97414 11.2018 4.99514 11.2264 5.0177C11.8469 5.48124 12.2 6.22679 12.2 7.00706C12.2 7.82411 11.8128 8.60309 11.1369 9.06006L6.33427 12.3177C5.96687 12.564 5.53886 12.7 5.10005 12.7C4.71017 12.7 4.32244 12.5901 3.97341 12.3861L3.96664 12.3821C3.22634 11.9381 2.80005 11.138 2.80005 10.2629V3.74208C2.80005 2.87815 3.22472 2.06797 3.96667 1.62297C4.70867 1.17794 5.61812 1.18551 6.3496 1.69167Z"
                fill="#ffffff"
              />
            </svg>
          )}
        </button>
      </Box>
      <Box className="flex min-w-[54px] select-none items-center justify-around rounded-r-3xl bg-w-black/50 py-[3px] pl-2 pr-3 text-center">
        <Typography
          variant="body2"
          className="w-[10px] font-medium text-w-white"
        >
          {selectedSnap + 1}
        </Typography>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M5.5 11L8.5 3"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Typography
          variant="body2"
          className="w-[10px] font-medium text-w-white"
        >
          {snapCount}
        </Typography>
      </Box>
    </Box>
  );
};
